<template>
  <div>
    <b-modal v-model="showModal"
      :title="textMessage"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg">
      <form autocomplete="off" @submit.prevent="submitForm">
        <div class="modal-body">

          <div v-if="typeanswer_id === 1">
            <!-- Sección para radio buttons -->
            <div class="row">
              <div class="form-group col-md-12">
                <div class="form-group col-md-12 text-right">
                  <button type="button" @click="addAnswer" class="btn btn-sm btn-success">Agregar Respuesta</button>
                </div>
                <div v-for="(answer, index) in form.answers" :key="index" class="form-group col-md-12">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <label class="mb-0">
                      <input type="radio" :checked="form.answers[index].selected == 1" :name="'answer_radio_group'" @change="handleRadioChange(index)" :value="1">
                      <input type="hidden" v-model="form.answers[index].answer_id" :name="'answer_' + index">
                      &nbsp;Respuesta {{ index + 1 }} &nbsp;<span class="asterisk">*</span>
                    </label>
                    <button type="button" @click.prevent="removeAnswer(index)" class="btn btn-sm btn-danger">Eliminar</button>
                  </div>
                  <ckeditor v-model="form.answers[index].text" :editor="editor" :config="editorConfigSimple"></ckeditor>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="typeanswer_id === 2">
            <!-- Sección para checkboxes -->
            <div class="row">
              <div class="form-group col-md-12">
                <div class="form-group col-md-12 text-right">
                  <button type="button" @click="addAnswer" class="btn btn-sm btn-success">Agregar Respuesta </button>
                </div>
                <div v-for="(answer, index) in form.answers" :key="index" class="form-group col-md-12">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <label class="mb-0">
                      <input type="checkbox" v-model="form.answers[index].selected">
                      &nbsp;Respuesta {{ index + 1 }} &nbsp;<span class="asterisk">*</span>
                    </label>
                    <button type="button" @click.prevent="removeAnswer(index)" class="btn btn-sm btn-danger">Eliminar</button>
                  </div>
                  <ckeditor v-model="form.answers[index].text" :editor="editor" :config="editorConfigSimple"></ckeditor>
                </div>
              </div>
            </div>
          </div>

          <input type="hidden" v-model="question_id" name="question_id">
          <div class="row">
            <div class="col-12 text-right">
              <span v-if="selectedValid" class="text-danger" style="font-size: 11px;"><b>Dede poseer minimo 01 repuesta marcada como acierto</b></span>
            </div>
          </div>

        </div>
        <div class="modal-footer">

          <button class="btn btn-sm btn-danger" type="button" @click="cancel"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
          <button type="submit" class="btn btn-sm btn-success"> <i class="fas fa-download fa-fw"></i> Guardar</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';
import { ClassicEditor, editorConfigSimple } from '../../../../ckeditor';
import CKEditor from '@ckeditor/ckeditor5-vue2';

export default {
  components: {BModal, 'ckeditor': CKEditor.component},
  props: ['question_id', 'answer_number', 'typeanswer_id', 'showModal'],
  data() {
    return {
      editor: ClassicEditor,
      editorConfigSimple,
      form: {answers: []},
      loading: false,
      textMessage: 'Agregar o Eliminar Respuestas',
      selectedValid: false,
    }
  },
  created() {
    this.form.answers = [];
    this.getRecord();
  },
  computed: {
    disabledCheckboxes() {
      const selectedCheckboxes = this.form.answers.filter(answer => answer.selected);
      return selectedCheckboxes.length >= this.answer_number;
    },
  },
  methods:{
    // Extrae el texto plano del HTML que genera CKEditor, para poder validar
    // respuestas vacías o duplicadas sin que el marcado interfiera.
    plainText(html) {
      const div = document.createElement('div');
      div.innerHTML = html || '';
      return (div.textContent || '').replace(/\u00a0/g, ' ').trim();
    },
    handleCheckboxChange(index) {
      const selectedCheckboxes = this.form.answers.filter(answer => answer.selected);

      if (selectedCheckboxes.length > this.answer_number) {
        // Si se excede la cantidad permitida, deselecciona el checkbox actual
        this.form.answers[index].selected = false;
      }

      // Deshabilita los checkboxes no seleccionados que superan la cantidad máxima
      this.form.answers.forEach((answer, i) => {
        if (!answer.selected && selectedCheckboxes.length >= this.answer_number) {
          answer.disabled = true;
        } else {
          answer.disabled = false;
        }
      });
    },
    handleRadioChange(index) {
      // Establece el valor de 'selected' de todos los radio buttons a 0
      this.form.answers.forEach((answer, i) => {
        answer.selected = 0;
      });

      // Establece el valor de 'selected' del radio button actual a 1
      this.form.answers[index].selected = 1;

      // Puedes realizar acciones adicionales si es necesario
      // console.log(`Radio ${index} seleccionado: ${this.form.answers[index].selected}`);

    },
    close(bvModalEvent) {
      this.selectedValid = false;
      this.textMessage = 'Agregar o Eliminar Respuestas'
      this.$emit('update:showModal', false)
      this.$emit('getRecords')
    },
    cancel(bvModalEvent) {
      this.selectedValid = false;
      this.textMessage = 'Agregar o Eliminar Respuestas'
      this.$emit('update:showModal', false)
    },
    getRecord() {
      this.loading = true;

      if (this.question_id) {
        this.form.answers = []; // Restablecer a un array vacío antes de la nueva petición

        axios.get(`/administration/courses/answers/${this.question_id}`)
          .then(response => {
            this.textMessage = 'Agregar o Eliminar Respuestas';

            if (Array.isArray(response.data) && response.data.length > 0) {
              const selectedCheckboxes = response.data.filter(answer => answer.selection === 1);
              this.form.answers = response.data.map(answer => ({
                answer_id: answer.id,
                text: answer.answer,
                question_id: answer.question_id,
                selected: answer.selection === 1,
                disabled: selectedCheckboxes.length >= this.answer_number && answer.selection !== 1,
              }));
            }
          })
          .catch(error => {
            toastr.error('Hubo un error en la solicitud', 'Error', { icon: 'fa fa-times-circle' });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.form.answers = []; // Restablecer a un array vacío si no hay question_id
        this.loading = false;
      }
    },
    addAnswer() {
      if (!this.form.answers) {
        this.$set(this.form, 'answers', []); // Inicializa this.form.answers como un array
      }
      this.form.answers.push({ text: '', question_id: this.question_id, selected: false }); // Agrega un nuevo campo de respuesta vacío al arreglo
    },
    removeAnswer(index) {
      if (index >= 0 && index < this.form.answers.length) {
        this.form.answers.splice(index, 1);
      }
    },
    submitForm() {
      this.loading = true;

      // Solo validar cuando existan respuestas. Si no hay ninguna, se permite
      // guardar sin respuestas (el backend elimina todas las existentes).
      if (this.form.answers.length > 0) {
        let countSelected = 0;

        // Validar respuestas seleccionadas
        this.form.answers.forEach(answer => {
          if (answer.selected === true || answer.selected === 1) {
            countSelected++;
          }
        });

        if (countSelected === 0) {
          this.selectedValid = true;
          this.loading = false;
          return;
        }

        // VALIDAR RESPUESTAS VACÍAS. CKEditor devuelve marcado (<p>&nbsp;</p>)
        // aunque no se haya escrito nada, por eso se compara el texto plano.
        const hasEmpty = this.form.answers.some(a => this.plainText(a.text) === '');

        if (hasEmpty) {
          toastr.error(
            'Debe completar el texto de todas las respuestas',
            'Error',
            { icon: 'fa fa-times-circle' }
          );

          this.loading = false;
          return;
        }

        // VALIDAR RESPUESTAS DUPLICADAS
        const answersText = this.form.answers.map(a => this.plainText(a.text).toLowerCase());

        const hasDuplicates = answersText.some((item, index) => {
          return answersText.indexOf(item) !== index;
        });

        if (hasDuplicates) {
          toastr.error(
            'No puede registrar respuestas iguales',
            'Error',
            { icon: 'fa fa-times-circle' }
          );

          this.loading = false;
          return;
        }
      }

      this.form.question_id = this.question_id;

      axios.post('/administration/courses/answers', this.form)
        .then(response => {
          if (response.data.success === false) {
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
          }
          this.close();
        })
        .catch(error => {
          toastr.error('Hubo un error en la solicitud', 'Error', { icon: 'fa fa-times-circle' });
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}

</script>
<style>
.ck-rounded-corners .ck.ck-balloon-panel {
  z-index: calc(var(--ck-z-panel) + 41) !important;
}
</style>